import React, {useCallback} from 'react';
import styled from 'styled-components';
import {Form} from 'react-final-form';
import {FORM_ERROR} from 'final-form';
import {Link, Typography} from '@material-ui/core';

import Logo from '../components/LoginSectionLogo';
import {TextField, FormError} from '../components/Form';
import {SecondarySubmitButton} from '../utils/commonStyledComponents';
import {passwordRecovery} from '../utils/api';

// Rebranding 2026 · ForgotPassword wrappata in gc-loginpage + gc-glowbox come Login
const ForgotPassword = () => {
  const onSubmit = useCallback(async data => {
    try {
      await passwordRecovery(data);
    } catch (e) {
      return {
        [FORM_ERROR]: e.response?.data?.message,
      };
    }
  }, []);

  return (
    <div className="gc-loginpage">
      <div className="gc-loginpage__gwm" />
      <main className="gc-loginpage__main">
        <div className="gc-login2">
          <Logo />

          <div className="gc-glowbox">
            <div className="gc-glowbox__inner">
              <h1 className="gc-login2__title">Recupero Password</h1>

              <Form
                onSubmit={onSubmit}
                render={({
                  handleSubmit,
                  submitting,
                  submitError,
                  submitSucceeded,
                }) => (
                  <StyledForm onSubmit={handleSubmit}>
                    {!submitting && submitError && (
                      <FormError>{submitError}</FormError>
                    )}

                    {submitSucceeded && (
                      <Subtitle>
                        La tua password è stata modificata e una copia ti è stata
                        inviata alla email associata al tuo account.
                      </Subtitle>
                    )}

                    <TextField
                      name="username"
                      label="username o indirizzo e-mail"
                      fullWidth
                      required
                    />

                    <SecondarySubmitButton
                      text="Invia"
                      disabled={submitting}
                      loading={submitting}
                      fullWidth
                    />
                  </StyledForm>
                )}
              />
            </div>
          </div>

          <p className="gc-login2__help">
            <Link href="/login" variant="body2">Torna alla login</Link>
          </p>
        </div>
      </main>
    </div>
  );
};

export default ForgotPassword;

const Subtitle = styled(Typography).attrs({
  component: 'p',
  variant: 'body1',
  align: 'center',
})`
  margin: 16px 0;
  background: var(--gc-tint-gold-50);
  border: solid 1px var(--gc-tint-gold-100);
  color: var(--gc-tint-gold-700);
  padding: 14px 18px;
  border-radius: 8px;
`;

const StyledForm = styled.form`
  display: flex;
  flex-direction: column;
  margin-top: 8px;
`;
